import { createContext, useCallback, useContext, useRef, useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel } from "../components/ui/alert-dialog";

const EditConfirmContext = createContext(null);

export function EditConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, label: "" });
  const resolverRef = useRef(null);

  const confirmEdit = useCallback((label) => {
    setState({ open: true, label });
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  }, []);

  const resolve = (result) => {
    setState((s) => ({ ...s, open: false }));
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
  };

  return (
    <EditConfirmContext.Provider value={confirmEdit}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(open) => { if (!open) resolve(false); }}>
        <AlertDialogContent data-testid="edit-confirm-dialog" className="bg-igc-surface border-igc-gold/20 text-igc-cream">
          <AlertDialogHeader>
            <AlertDialogTitle data-testid="edit-confirm-title" className="font-serif">Confirm Edit</AlertDialogTitle>
            <AlertDialogDescription data-testid="edit-confirm-description" className="text-igc-muted">
              Are you sure you want to edit {state.label}? This action will update the record.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="edit-confirm-cancel-button" onClick={() => resolve(false)} className="bg-igc-surfaceLight border-igc-gold/20 text-igc-cream hover:bg-igc-surfaceLight/70 hover:text-igc-cream">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction data-testid="edit-confirm-confirm-button" onClick={() => resolve(true)} className="bg-igc-gold hover:bg-igc-goldHover text-black">
              Confirm
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </EditConfirmContext.Provider>
  );
}

export function useEditConfirm() {
  return useContext(EditConfirmContext);
}
